import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 17"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "1.3",
      d: "M2 12.5c1.138 0 2.8-.546 4.225-4.57.356-1.049.807-3.43 2.191-3.43s1.798 2.347 2.197 3.43C11.425 10.41 13.05 12.5 15 12.5"
    }, null, -1)
  ]))]))
}
export default { render: render }